<template>
  <!--This is the article dialog, which opens from the front page-->
  <v-card v-if="currentTranslation" style="position:relative;">
    <ReportDialog
      ref="reportDialog"
      @updatearticle="updatearticle"
    ></ReportDialog>
    <CommentDialog
      ref="commentDialog"
      @updatearticle="updatearticle"
    ></CommentDialog>
    <FullImageDialog ref="fullImageDialog"></FullImageDialog>
    <!-- <SharingDialog ref="sharingDialog"></SharingDialog> -->
    <!-- <v-toolbar flat class="pr-0 mr-0 pb-0 mb-0">
      <v-spacer></v-spacer>
    </v-toolbar>-->

    <v-btn
      color="orange lighten-1"
      :title="$t('close window')"
      class="mr-1 mt-1"
      outlined
      fab
      dark
      large
      :to="{ name: `frontpage`, params: {} }"
      replace
      style="position:absolute; z-index:1; top:0; right:0;"
    >
      <v-icon>close</v-icon>
    </v-btn>
    <!-- <v-btn color="error" icon large  @click="closeDialog" >
      <v-icon>close</v-icon>
    </v-btn> -->
    <span class="white--text ma-0 pa-0" style="max-height:1px;">.</span>
    <v-img
      app
      v-if="
        articledata.Media &&
          articledata.Media.length > 0 &&
          articledata.ArticleType == 'rss_article'
      "
      :src="
        `${articledata.Media[0]['s3url']}${
          articledata.Media[0].FileSize > 0 ? '-web.jpg' : ''
        }`
      "
      max-height="100px"
      contain
    ></v-img>
    <v-img
      app
      v-else-if="articledata.Media && articledata.Media.length > 0"
      :src="
        `${articledata.Media[0]['s3url']}${
          articledata.Media[0].FileSize > 0 ? '-web.jpg' : ''
        }`
      "
      :width="100 + '%'"
      max-height="400px"
      :ratio="1.77"
      @click="$refs.fullImageDialog.openDialog(articledata)"
    ></v-img>
    <!-- <v-img v-else :src="`/wenewz_middle_2color.svg`" width="100%" :ratio="1.77"></v-img> -->
    <div v-else class="pb-4 pt-4">
      <v-img :src="`/lrVxWoHA.png`" width="100%" height="150px" contain />
    </div>
    <div v-if="articledata.ArticleType !== 'rss_article'">
      <v-divider></v-divider>
      <v-divider></v-divider>
      <v-divider></v-divider>
    </div>

    <v-card-title class="pr-0">
      <span class="headline" v-html="currentTranslation.Title"></span>
    </v-card-title>
    <v-card-text class="pr-0">
      <div style="display:flex;">
        <!-- 
      <router-link to="/user">
        <span class="font-weight-bold"> Users_id : {{articledata.Users_id}} </span>
        </router-link>-->
        <span class="font-weight-bold">{{ articledata.Author }}</span>
        <span class="font-italic pl-3">
          {{ $t("Posted") }}:
          {{ articledata.Created | localizeDate | moment("LL") }}
        </span>
      </div>

      <p class="title" v-html="currentTranslation.Content"></p>
      <a :href="articledata.Link" v-if="articledata.Link" target="_blank">{{
        articledata.Link
      }}</a>
      <!-- <span>({{articledata.Link}})</span> -->

      <!--Normal-->
      
      <v-row v-if="$vuetify.breakpoint.smAndUp" class="ma-0 pa-0">
        <!-- <v-col>
               <textarea outlined ref="text" :value="ShareAbleUrl"></textarea>
                <v-btn @click="copyThisUrl">
                  Copy Url To Clipboard
                </v-btn>
                <button onclick="getElementById('demo').innerHTML=Date()">What day is today?</button><p id="demo"></p>
                <v-btn @click="getUrlDown">find</v-btn>
            </v-col>

            <v-col>
              <v-menu offset-y :close-on-content-click="false">
                <template v-slot:activator="{ on }">
                  <v-btn text v-on="on" class=" pl-2" @click="getUrlDown">
                    <v-icon medium>fas fa-share-alt</v-icon>
                  </v-btn>
                </template>
                <v-list>
                <v-list-item>
                    <textarea outlined ref="text" :value="ShareAbleUrl"></textarea>
                <v-btn @click="copyThisUrl">
                  Copy Url To Clipboard
                </v-btn>
                  </v-list-item>
                </v-list>
              </v-menu>
        </v-col>-->

        <!--Likes-->
        <v-col cols="12" class="pr-0 pl-0 pb-0" v-if="false">
          <v-row class="ma-0 pa-0">
            <v-col cols="auto" class="pa-0 pt-2 pl-2">
              <v-btn
                v-if="liked === false"
                icon
                color="error"
                @click="increaseLike"
                class="likeAnimation"
              >
                <span
                  style="font-size: 0.8em;position: absolute; color: #000; left: 50%; top: 40%; transform: translateY(-50%) translateX(-50%);"
                  >{{ counter }}</span
                >
                <v-icon large class="far fa-heart"></v-icon>
              </v-btn>
              <v-btn
                v-else
                icon
                color="error"
                @click="decreaseLike"
                class="likeAnimation"
              >
                <span
                  style="position: absolute; color: #fff; left: 50%; top: 35%; transform: translateY(-50%) translateX(-50%);"
                  >{{ counter }}</span
                >
                <v-icon large>fas fa-heart</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <!--Views-->
        <v-col cols="auto" class="ml-3 pt-0">
          <v-row>
            <v-col cols="auto" class="pa-0 pt-3">
              
            </v-col>
            <v-col cols="auto" class="pa-0 pt-3 pl-2">
              <span class="pl-3 subtitle-1 error--text">
                {{ articledata.TotalViews }}
              </span>
            </v-col>
            <v-col cols="auto" class="pa-0 pt-3 pl-2">
              <span class="pl-3 subtitle-1">{{ $t("Views") }}</span>
            </v-col>
          </v-row>
        </v-col>
        <!--Comments-->
        <v-col cols="auto" class="pl-0" v-if="articledata.Comments">
          <v-row>
            <v-col cols="auto" class="pa-0">
              <span class="ml-12">
                <v-icon medium>far fa-comment-alt</v-icon>
              </span>
            </v-col>
            <v-col cols="auto" class="pa-0">
              <span class="pl-3 subtitle-1 error--text">
                {{ articledata.CommentsCount }}
              </span>
            </v-col>
            <v-col cols="auto" class="pa-0">
              <span class="subtitle-1 pl-3">{{ $t("Comments") }}</span>
            </v-col>
          </v-row>
        </v-col>
        <!--Tags-->
        <v-col class="pb-0">
          <div class="text-end">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-width="940"
              offset-x
              nudge-left="900"
              nudge-bottom="55"
            >
              <template v-slot:activator="{ on }">
                <v-btn icon color="warning" v-on="on" large class="pa-1 mt-1">
                  <v-icon>fas fa-tags</v-icon>
                </v-btn>
              </template>
              <v-card style="background-color: #eee; border:solid black 1px;">
                <v-card-text class="pr-0">
                  <v-row>
                    <v-col md="12">
                      <span class="body-1 font-weight-bold pr-2"
                        >{{ $t("GeoTagging") }} :</span
                      >
                      <v-chip
                        v-for="tag in articledata.GeoTags"
                        :key="tag.id"
                        color="green"
                        text-color="white"
                        class="mb-3 mt-3 mr-12"
                      >
                        #{{ tag.Label }}
                        <v-icon right>navigation</v-icon>
                      </v-chip>
                    </v-col>
                    <v-col md="12">
                      <span class="body-1 font-weight-bold pr-2"
                        >{{ $t("Tagging") }} :</span
                      >
                      <v-chip
                        v-for="tag in articledata.Tags"
                        :key="tag.id"
                        color="orange"
                        text-color="white"
                        class="mb-3 mt-3"
                      >
                        #{{ tag.Label }}
                        <v-icon right>short_text</v-icon>
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-menu>
          </div>
        </v-col>
        <!--Report-->
        <v-col cols="auto" v-if="isLoggedIn == true" class="pb-0">
          <div class="text-end">
            <v-btn
              color="error"
              large
              icon
              @click.stop="
                $refs.reportDialog.openDialog({
                  reportedId: articledata.id,
                  reportType: 'article',
                  content: articledata.Content[0]['Title'],
                })
              "
            >
              <v-icon>fas fa-exclamation-triangle</v-icon>
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" class="pt-0">
          <!--
            Share on facebook.  
            Code found at: /client/public/index.html
          -->
          <v-row class="ma-0 pa-0">
            <v-col cols="auto" class="ma-0 pa-0 pt-2">
              <div
                class="fb-share-button"
                :data-href="currentURL"
                data-layout="button_count"
                data-size="large"
              ></div>
            </v-col>
            <!--Manually copy-->
            <v-col class="ma-0 pa-0 pl-3" cols="1">
              <v-menu offset-y :close-on-content-click="false">
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" @click="getUrlDown">
                    <v-icon medium>fas fa-share-alt</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <textarea
                      auto-grow
                      :no-resize="true"
                      row-height="30"
                      readonly
                      rows="2"
                      outlined
                      ref="gettingTheUrl"
                      v-model="currentURL"
                      cols="50"
                    ></textarea>
                    <v-btn @click="copyThisUrl">{{
                      $t("Copy Url To Clipboard")
                    }}</v-btn>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!--Phone-->
      <v-row v-else class="ma-0 pa-0">
        <!--Like-->
        <v-col cols="6" v-if="false">
          <v-row>
            <v-col cols="12" class="pr-0 pl-0 pb-0">
              <v-row class="ma-0 pa-0">
                <v-col cols="auto" class="pa-0 pt-2 pl-2">
                  <v-btn
                    v-if="liked === false"
                    icon
                    color="error"
                    @click="increaseLike"
                    class="likeAnimation"
                  >
                    <span
                      style="font-size: 0.8em;position: absolute; color: #000; left: 50%; top: 40%; transform: translateY(-50%) translateX(-50%);"
                      >{{ counter }}</span
                    >
                    <v-icon large class="far fa-heart"></v-icon>
                  </v-btn>
                  <v-btn
                    v-else
                    icon
                    color="error"
                    @click="decreaseLike"
                    class="likeAnimation"
                  >
                    <span
                      style="position: absolute; color: #fff; left: 50%; top: 35%; transform: translateY(-50%) translateX(-50%);"
                      >{{ counter }}</span
                    >
                    <v-icon large>fas fa-heart</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <!--Actions-->
        <v-col cols="auto">
          <v-row class="ma-0 pa-0">
            <!--Tags-->
            <v-col cols="2" class="ma-0 pa-0 pt-2">
              <div class="text-center">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-width="710"
                  offset-x
                  nudge-left="400"
                  nudge-bottom="55"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      color="warning"
                      v-on="on"
                      large
                      class="pa-1 mt-1"
                    >
                      <v-icon>fas fa-tags</v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-text class="pr-0">
                      <v-row>
                        <v-col cols="auto" class="py-0">
                          <span class="body-1 font-weight-bold pr-2"
                            >{{ $t("GeoTagging") }} :</span
                          >
                          <v-chip
                            v-for="tag in articledata.GeoTags"
                            :key="tag.id"
                            color="green"
                            text-color="white"
                            class="mb-3 mt-3 mr-12"
                          >
                            #{{ tag.Label }}
                            <v-icon right>navigation</v-icon>
                          </v-chip>
                        </v-col>
                        <v-col cols="auto" class="py-0">
                          <span class="body-1 font-weight-bold pr-2"
                            >{{ $t("Tagging") }} :</span
                          >
                          <v-chip
                            v-for="tag in articledata.Tags"
                            :key="tag.id"
                            color="orange"
                            text-color="white"
                            class="mb-3 mt-3"
                          >
                            #{{ tag.Label }}
                            <v-icon right>short_text</v-icon>
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </div>
            </v-col>
            <v-spacer></v-spacer>
            <!--Report-->
            <v-col cols="2" class="ma-0 pa-0 pt-3" v-if="isLoggedIn == true">
              <div class="text-center">
                <v-btn
                  color="error"
                  large
                  icon
                  @click.stop="
                    $refs.reportDialog.openDialog({
                      reportedId: articledata.id,
                      reportType: 'article',
                      content: articledata.Content[0]['Title'],
                    })
                  "
                >
                  <v-icon>fas fa-exclamation-triangle</v-icon>
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" class="pt-0 pt-3">
              <!--
                Share on facebook.  
                Code found at: /client/public/index.html
              -->
              <v-row class="ma-0 pa-0">
                <v-col cols="auto" class="ma-0 pa-0 pt-2">
                  <div
                    class="fb-share-button"
                    :data-href="currentURL"
                    data-layout="button_count"
                    data-size="large"
                  ></div>
                </v-col>
                <!--Manually copy-->
                <v-col class="ma-0 pa-0" cols="auto">
                  <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on" @click="getUrlDown">
                        <v-icon medium>fas fa-share-alt</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item>
                        <textarea
                          style="height: 1px; width: 1px; position: fixed; bottom: 0; right: 0;"
                          auto-grow
                          :no-resize="true"
                          row-height="30"
                          readonly
                          rows="2"
                          outlined
                          ref="gettingTheUrl"
                          v-model="currentURL"
                          cols="50"
                        ></textarea>
                        <v-btn small @click="copyThisUrl">{{
                          $t("Copy Url To Clipboard")
                        }}</v-btn>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <!--Report-->
        <!--Views-->
        <v-col cols="6" class="mr-0 ml-0 pl-0">
          <v-row class="ma-0 pa-0">
            <v-col cols="auto" class="ma-0 pa-0">
              <span class="pl-2 pr-1 subtitle-1 error--text">
                {{ articledata.TotalViews }}
              </span>
            </v-col>
            <v-col cols="auto" class="ma-0 pa-0">
              <span class="subtitle-1">{{ $t("Views") }}</span>
            </v-col>
          </v-row>
        </v-col>
        <!--Comments-->
        <v-col cols="6" class="ml-0 pl-0">
          <v-row>
            <v-col cols="auto" class="ma-0 pa-0">
              <span class="pl-3 subtitle-1 error--text">
                {{ articledata.CommentsCount }}
              </span>
            </v-col>
            <v-col cols="auto" class="ma-0 pa-0 pt-1">
              <span class="body-1 pl-2">{{ $t("Comments") }}</span>
            </v-col>
            <v-col cols="auto"></v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-divider></v-divider>
      <!--Comments-->
      <!--Article got comments enabled-->
      <div v-if="articledata.Comments == 1" class="pb-6">
        <div v-if="isLoggedIn == true">
          <v-text-field
            auto-grow
            :label="$t('Write an comment')"
            @keyup.enter="submitComment"
            v-model="thisComment"
          ></v-text-field>
        </div>
        <div v-else>
          {{ $t("Only logged in users are enabled to comment on articles") }}
        </div>

        <v-card
          v-for="item in articledata.CommentsData"
          :key="`comment_` + item.id"
          class="pb-2 mb-3 grey lighten-2"
          outlined
        >
          <v-container class="pb-0">
            <v-row>
              <v-col
                cols="auto"
                class="text-center"
                v-if="$vuetify.breakpoint.smAndUp"
              >
                <v-avatar size="80" color="teal">
                  <img v-if="item.image" :src="item.image" alt="X" />
                  <v-icon v-else>fas fa-user</v-icon>
                </v-avatar>
              </v-col>
              <v-col class="pb-0">
                <div class="overline">
                  {{ item.Created | localizeDate | moment("LLLL") }}
                  ({{ item.Created | localizeDate | moment("from") }})
                </div>

                <div class="title">{{ item.Author }}</div>
                <div v-html="item.Content"></div>

                <div>
                  <v-divider class="my-1"></v-divider>

                  <v-hover v-slot:default="{ hover }" v-if="isLoggedIn">
                    <v-btn
                      small
                      :text="!hover"
                      color="success"
                      @click.stop="
                        $refs.commentDialog.openDialog({
                          Content: '',
                          Articles_id: articledata.id,
                          ArticleComments_id: item.id,
                        })
                      "
                      >{{ $t("Reply") }}</v-btn
                    >
                  </v-hover>
                  <v-hover v-slot:default="{ hover }">
                    <v-btn
                      small
                      :text="!hover"
                      color="error"
                      @click.stop="
                        $refs.reportDialog.openDialog({
                          reportedId: item.id,
                          reportType: 'comment',
                          content: item.Content.substring(0, 100),
                        })
                      "
                      >{{ $t("Report") }}</v-btn
                    >
                  </v-hover>
                </div>

                <div class="subcomments">
                  <v-card
                    v-for="subComment in item.Child"
                    :key="`subComment_` + subComment.id"
                    class="pt-2 mt-3"
                    color="grey lighten-5"
                    outlined
                  >
                    <v-container class="pb-0">
                      <v-row>
                        <v-col
                          cols="auto"
                          class="text-center"
                          v-if="$vuetify.breakpoint.smAndUp"
                        >
                          <v-avatar size="50" color="teal">
                            <img
                              v-if="subComment.image"
                              :src="subComment.image"
                              alt="X"
                            />
                            <v-icon small v-else>fas fa-user</v-icon>
                          </v-avatar>
                        </v-col>
                        <v-col class="pb-0">
                          <div class="overline">
                            {{
                              subComment.Created | localizeDate | moment("LLLL")
                            }}
                            ({{
                              subComment.Created
                                | localizeDate
                                | moment("from")
                            }})
                          </div>

                          <div class="title">{{ subComment.Author }}</div>
                          <div>{{ subComment.Content }}</div>
                          <div>
                            <v-divider class="my-1"></v-divider>
                            <v-hover
                              v-slot:default="{ hover }"
                              v-if="isLoggedIn"
                            >
                              <v-btn
                                small
                                :text="!hover"
                                color="success"
                                @click.stop="
                                  $refs.commentDialog.openDialog({
                                    Content: '',
                                    Articles_id: articledata.id,
                                    ArticleComments_id: item.id,
                                  })
                                "
                                >Svar</v-btn
                              >
                            </v-hover>
                            <v-hover v-slot:default="{ hover }">
                              <v-btn
                                small
                                :text="!hover"
                                color="error"
                                @click.stop="
                                  $refs.reportDialog.openDialog({
                                    reportedId: subComment.id,
                                    reportType: 'comment',
                                    content: subComment.Content.substring(
                                      0,
                                      100
                                    ),
                                  })
                                "
                                >{{ $t("Report") }}</v-btn
                              >
                            </v-hover>
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </div>
      <!--Article do NOT have comments enabled-->
      <div v-else>
        <p>{{ $t("Comments have been disabled for this article") }}</p>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import messages from "../modules/lang/main/export";
import ReportDialog from "@/components/dialogs/report_dialog.vue";
import CommentDialog from "@/components/dialogs/kommentar_dialog.vue";
import FullImageDialog from "@/components/dialogs/fullImageDialog.vue";
import SharingDialog from "@/pages/frontpage/components/dialog/shareDialog.vue";
export default {
  props: ["articledata"],
  i18n: { messages },
  components: {
    ReportDialog,
    FullImageDialog,
    CommentDialog,
    SharingDialog
  },
  data() {
    return {
      thisComment: "",
      // Take current url of the browser window. Used in manually copying
      currentURL: window.location.href,
      liked: false,
      menu: false,
      isCommentsOpen: false,
      counter: 0,
      dialog: false,
      list: [{ name: "item 1" }, { name: "item 2" }, { name: "item 3" }],

      currentLang:
        localStorage.getItem("setlanguage") ||
        localStorage.getItem("detectedlanguage") ||
        "en",
    };
  },
  computed: {
    ...mapGetters(["isLoggedIn", "authStatus", "userId"]),
    currentTranslation() {
      return (
        this.articledata.Content.find((el) => el.Lang == this.currentLang) ||
        this.articledata.Content.find(
          (el) => el.Lang == this.articledata.OrgLanguage
        )
      );
    },
    lastIndex() {
      return this.subComment[this.subComment.length - 1];
    },
    // Not in use i belive - bjorn
    ShareAbleUrl() {
      if (this.articledata) {
        return location.origin + "/api/share/" + this.articledata.id;
      } else {
        return location;
      }
    },
  },
  mounted() {
    if (this.isLoggedIn && this.authStatus == "") {
      this.$store
        .dispatch("loginWithToken")
        .then((resp) => {
          // setTimeout(() => this.$router.push("/"), 600);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    /*
      Getting an SDK from facebook, after 0.5 sec. 
        - We then clear the setTimeout, stopping the loop.
        - Then afterward we take the key of this page, made within getUrlDown
          - manually making the wenewz path   + adding the id of current article.
        - We run the FB.XFBML.parse(); once, which is the call to get the SDK key.
    */
    clearTimeout(this.gettingFacebook);
    this.gettingFacebook = setTimeout(() => this.loadFacebookSDK(), 500);
    this.getUrlDown();
    FB.XFBML.parse();
  },
  methods: {
    // Getting the SDK key using their function
    loadFacebookSDK(){
      FB.XFBML.parse();
    },
    submitComment() {
      this.$store
        .dispatch("POST_COMMENT", {
          Articles_id: this.articledata.id,
          Content: this.thisComment,
        })
        .then((res) => {
          // console.log(res.data);
          this.thisComment = "";
          this.$emit("updatearticle");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // For the like button
    increaseLike() {
      this.counter++;
      this.liked = true;
    },
    decreaseLike() {
      this.counter--;
      this.liked = false;
    },
    // Manual copy of the window url.
    copyThisUrl() {
      this.$refs.gettingTheUrl.select();
      document.execCommand("copy");
    },
    // The path in regard of posting on facebook
    getUrlDown() {
      this.currentURL =
        "https://wenewz.com" + "/api/share/" + this.articledata.id;
    },
    updatearticle() {
      this.$emit("updatearticle");
    },
  },
};
</script>

<style scoped>
v-card v-img {
  max-width: 100%;
  height: auto;
}

#rcorners3 {
  border-radius: 15px 50px;
  background: #eee;
  padding: 10px;
  border: solid 1px red;
}

.likeAnimation:active {
  transform: scale(2);
  transition: 0.3s;
}
/* .spinny{
  transition: all 3s;
}
.spinny:hover {
  transition:  0.3s;
  transform: scale(1.5)
}
.spinny:active {
  transition:  0.1s;
  transform: scale(2);
} */
</style>
